import { useTargetingSettingsContext } from '../context/TargetingSettingsContext';
import type { RequiredParamsType, RequiredTargetingSectionKeysType } from '../context/types';
import { TargetingPresetElement } from '../TargetingPresetElement/TargetingPresetElement';

type RequiredTargetingElementProps = {
  sectionKey: RequiredTargetingSectionKeysType;
  elementIndex: number;
};

export const RequiredTargetingElement = ({ sectionKey, elementIndex }: RequiredTargetingElementProps) => {
  const element = useTargetingSettingsContext(
    (state: RequiredParamsType | null) => state?.sections[sectionKey]?.elements?.[elementIndex]
  );

  if (!element?.mainOption) return null;

  return (
    <TargetingPresetElement
      sectionKey={sectionKey}
      elementIndex={elementIndex}
      mainOption={element.mainOption}
      subOptions={element.subOptions}
    />
  );
};
